import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication';
import { inject } from '@angular/core';

export const nonAuthGuard: CanActivateFn = (route, state) => {
  const redirectToCustomerSelect = () =>
    inject(Router).createUrlTree(['customer-select']);

  return inject(AuthenticationService).isLoggedIn()
    ? redirectToCustomerSelect()
    : true;
};
